import { PROJECTS } from "./../utils/constants.js";
import ProjectCard from "./../common/ProjectCard";
import Title from "./Title";

export default function Projects() {
    return (
        <>
        <Title text="My Projects" image={"./wand.png"} />
        <div className="flex flex-col sm:grid sm:grid-cols-2 xl:grid-cols-3 gap-[30px] py-[40px]">
            {PROJECTS.map(({ id, title, img, stack, text, url, badges }) => (
                <ProjectCard
                    key={id}
                    url={url}
                    image={img}
                    alt={title}
                    title={title}
                    stack={stack}
                    text={text}
                    badges={badges}
                />
            ))}
        </div>
        </>
    );
}
